import GraphDashboard from './GraphDashboard';

const GraphDashboardInfo = {
  component: GraphDashboard,
  initializeComponent: (compCfg) => {
    const mutComp = compCfg;
    const { defaults, ...rest } = compCfg.configuration;
    mutComp.configuration = rest;

    const computeConfiguration = (cfg, compDefaults = {}) => {
      const type = cfg.type || cfg.chartType;
      return { ...(type && defaults && defaults[type] || {}), ...compDefaults, ...cfg };
    };

    mutComp.components = (compCfg.components || []).map((childCfg) => {
      // eslint-disable-next-line prefer-const
      let { configurations, defaults: compDefaults, ...configRest } = childCfg.configuration;
      if (configurations) {
        configRest.configurations = Object.keys(configurations).reduce((cfgs, name) => {
          cfgs[name] = computeConfiguration(configurations[name], compDefaults);
          return cfgs;
        }, {});
      } else if (compCfg) {
        configRest = computeConfiguration(configRest);
      }
      const { title, name, barActions, ...cleanedConfig } = configRest;
      return {
        ...childCfg,
        title,
        name,
        barActions,
        configuration: cleanedConfig,
      };
    });
  },
};

export default GraphDashboardInfo;
